import React from 'react';
import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import { Add as AddIcon, Computer as ComputerIcon } from '@mui/icons-material';
import type { Project } from '../types';

interface ProjectCardProps {
  project: Project | null;
  onClick: () => void;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({ project, onClick }) => {
  if (!project) {
    // New project card
    return (
      <Card sx={{ minWidth: 280, minHeight: 120 }}>
        <CardActionArea
          onClick={onClick}
          sx={{
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 120,
          }}
        >
          <CardContent sx={{ py: 2 }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <AddIcon sx={{ fontSize: 36, color: 'primary.main' }} />
              <Typography variant="h6" color="primary">
                Create New Project
              </Typography>
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  }

  return (
    <Card sx={{ minWidth: 280, minHeight: 120 }}>
      <CardActionArea onClick={onClick} sx={{ height: '100%', minHeight: 120 }}>
        <CardContent sx={{ py: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <ComputerIcon color="primary" />
            <Typography variant="h6" component="div" noWrap>
              {project.name}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Chip
              label={`${project.applications.length} Application${project.applications.length !== 1 ? 's' : ''}`}
              size="small"
              color="primary"
              variant="outlined"
            />
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
